import type {
    SmriqLastCompletedServiceOption,
    SmriqLastCompletedServiceSelection,
} from '../types/smriq.types';
import { isAutoMatch } from './isAutoMatch';

export const isSelectionOffered = (
    selection: SmriqLastCompletedServiceSelection,
    options: readonly SmriqLastCompletedServiceOption[],
): boolean =>
    isAutoMatch(selection) || options.some((option) => option.id === selection.service_option_id);
